import { COMPANY_NAME } from "@/lib/const.ts";

export const Copyright = () => {
  const currentYear = new Date().getFullYear();
  return (
    <span>
      &copy; {currentYear} {COMPANY_NAME}
    </span>
  );
};
